<app-container-standard title="Filler settings">
  <br>
  <div>
    <mat-form-field>
      <mat-select placeholder="Filler report receivers" (selectionChange)="updateEmailListForStockFiller()"
        [formControl]="emailList" multiple>
        <mat-select-trigger>
          {{emailList.value ? emailList.value[0] : ''}}
          <span *ngIf="emailList.value?.length > 1" class="example-additional-selection">
            (+{{emailList.value.length - 1}} {{emailList.value?.length === 2 ? 'other' : 'others'}})
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let admin of adminEmailList | async" [value]="admin.payload.doc.data().email">
          {{admin.payload.doc.data().email}}</mat-option>
      </mat-select>
    </mat-form-field>
    &nbsp;
  </div>
  <br><br>
  <div>
    <hh-button title="New Report" [loading]="loadingResult" (clickLisnt)="createFiller()"></hh-button>
    &nbsp;
    <button type="button" mat-raised-button  (click)="openPopup()">Schedule</button>
  </div>
  <br>
</app-container-standard>

<app-table-standard-layout [dataSource$]="combObs$" [title]="'Filling reports'" [rowActionButtons]="rowActionButtons"
  [columnSettings]="columnSettings"></app-table-standard-layout>